// Author thq
// Date 2021-07-05 16:11:33

class EmSppRequisitionDetSrd {
constructor({
        id = null,
        srdIdSpr = '',
        srdCodeSpa = '',
        srdIdBusiness = '',
        srdIdSpa = '',
        srdNameSpa = '',
        srdCodeSat = '',
        srdCodeEloc = '',
        srdSpaIdentCode = '',
        srdNum = '',
        srdRemark = ''}
= {}) {
    this.id = id;
    this.srdIdSpr = srdIdSpr;
    this.srdCodeSpa = srdCodeSpa;
    this.srdIdBusiness = srdIdBusiness;
    this.srdIdSpa = srdIdSpa;
    this.srdNameSpa = srdNameSpa;
    this.srdCodeSat = srdCodeSat;
    this.srdCodeEloc = srdCodeEloc;
    this.srdSpaIdentCode = srdSpaIdentCode;
    this.srdNum = srdNum;
    this.srdRemark = srdRemark;
}
}

function newEntity() {
return new EmSppRequisitionDetSrd();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.spareparts.emSppRequisitionDetSrd.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'srdIdSpr',
        label: 'label.em.spareparts.emSppRequisitionDetSrd.grid.srdIdSpr',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'srdCodeSpa',
        label: 'label.em.spareparts.emSppRequisitionDetSrd.grid.srdCodeSpa',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'srdNameSpa',
        label: 'label.em.spareparts.emSppRequisitionDetSrd.grid.srdNameSpa',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'srdCodeSat',
        label: 'label.em.spareparts.emSppRequisitionDetSrd.grid.srdCodeSat',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'srdCodeEloc',
        label: 'label.em.spareparts.emSppRequisitionDetSrd.grid.srdCodeEloc',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'srdNum',
        label: 'label.em.spareparts.emSppRequisitionDetSrd.grid.srdNum',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'srdSpaIdentCode',
        label: 'label.em.spareparts.emSppRequisitionDetSrd.grid.srdSpaIdentCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'srdRemark',
        label: 'label.em.spareparts.emSppRequisitionDetSrd.grid.srdRemark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    srdIdSprFilter : "",
    srdIdSpaFilter : "",
    srdIdBusinessFilter : "",
    srdCodeSpaFilter : "",
    srdNameSpaFilter : "",
    srdCodeSatFilter : "",
    srdCodeElocFilter : "",
    srdNumFilter : "",
    srdSpaIdentCodeFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'srdIdSprFilter',
        label: 'label.em.spareparts.emSppRequisitionDetSrd.filter.srdIdSpr',
        disabled: true,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'srdCodeSpaFilter',
        label: 'label.em.spareparts.emSppRequisitionDetSrd.filter.srdCodeSpa',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'srdCodeSatFilter',
        label: 'label.em.spareparts.emSppRequisitionDetSrd.filter.srdCodeSat',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'srdSpaIdentCodeFilter',
        label: 'label.em.spareparts.emSppRequisitionDetSrd.filter.srdSpaIdentCode',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'srdIdSpr',
        label: 'label.em.spareparts.emSppRequisitionDetSrd.entity.srdIdSpr',
        sortable: true,
        disabled: true,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'srdCodeSpa',
        label: 'label.em.spareparts.emSppRequisitionDetSrd.entity.srdCodeSpa',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emSppStorageInfoSti'
            ,correspondingField: 'stiCodeSpa'
            ,fieldsBindingByEntityModalSelected: '{"srdIdSpa":"stiIdSpa","srdIdBusiness":"id","srdNameSpa":"stiNameSpa","srdCodeSat":"stiCodeSat","srdCodeEloc":"stiCodeEloc","srdSpaIdentCode":"stiCode"}'
                }
        },
        {
        key: 'srdNameSpa',
        label: 'label.em.spareparts.emSppRequisitionDetSrd.entity.srdNameSpa',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'srdCodeSat',
        label: 'label.em.spareparts.emSppRequisitionDetSrd.entity.srdCodeSat',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'srdCodeEloc',
        label: 'label.em.spareparts.emSppRequisitionDetSrd.entity.srdCodeEloc',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'srdSpaIdentCode',
        label: 'label.em.spareparts.emSppRequisitionDetSrd.entity.srdSpaIdentCode',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'srdNum',
        label: 'label.em.spareparts.emSppRequisitionDetSrd.entity.srdNum',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
            ,required: true
                }
        },
        {
        key: 'srdRemark',
        label: 'label.em.spareparts.emSppRequisitionDetSrd.entity.srdRemark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmSppRequisitionDetSrd, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
